import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import {
	getAuth,
	signInWithCustomToken,
	storage,
	ref,
	uploadBytes,
	getDownloadURL,
} from "../firebase"; // deleteObject, updateMetaData
import { API_URL, scroll, getValFromLS, fmtBytes } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import InputFile from "../components/InputFile";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Nav from "./Nav";

const Upload = () => {
	const [user, setUser] = useState({});
	const [uploaded, setUploaded] = useState([]);
	const [fileMsg, setFileMsg] = useState({});
	const [file, setFile] = useState(null);
	const [uploads, setUploads] = useState([]);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [status, setStatus] = useState(5);

	/*
    0 - error
    1 - complete (uploaded)
    2 - initializing
    3 - initialized
    4 - uploading
    5 - idle
  */

	const formElement = useRef(null);
	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardUploadInit`);
			const params = {
				q: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					const bfcUploaded = json.uploaded.map((item) => {
						return {
							name: item.name,
							downloadUrl: item.downloadUrl,
							source: "bfc_registrations",
						};
					});

					const sponsorUploaded = json.sponsorUploaded.map((item) => {
						return {
							name: item.name,
							downloadUrl: item.downloadUrl,
							source: "sponsors",
						};
					});

					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setUploaded(bfcUploaded.concat(sponsorUploaded));
					setNames({ registrationId: json.registrationId });
					handleFirebAuth(json.firebToken);
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}

			scroll();
		};

		init();
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleFirebAuth = (token) => {
		const auth = getAuth();
		signInWithCustomToken(auth, token)
			.then(async (userCredential) => {
				// Signed in userCredential.user;

				setAlert({});
			})
			.catch((error) => {
				setAlert({
					type: "error",
					text: `Error ${error.message} (${error.code}).`,
				});
			});
	};

	const handleInitialize = (e) => {
		setErrors([]);
		setMsg({});

		if (!names.name) {
			setErrors(["name"]);
			setMsg({
				type: "error",
				text: "Please enter a descriptive name for this upload.",
			});

			formElement.current.file.value = "";
			handleUpdate("file", "");

			return false;
		}

		//console.log(e.target.files[0]);

		if (e.target.files[0]) {
			const fileData = e.target.files[0];
			setStatus(2);
			setFileMsg({
				type: "working",
				text: "",
			});
			const reader = new FileReader();

			reader.onload = (loadEvt) => {
				if (reader.readyState === 2) {
					if (fileData.size > 1999999999) {
						setStatus(0);
						setFileMsg({
							type: "error",
							text: `File upload size limited to around 1.75 GB.`,
						});
					} else {
						setFile(fileData);
						setStatus(3);
						setFileMsg({
							type: "notice",
							text: `File initialized (${fileData.type}${
								fileData.size ? `, ${fmtBytes(fileData.size)}` : ""
							})`,
						});
					}
				}
			};

			reader.readAsDataURL(e.target.files[0]);
		}
	};

	const handleUpload = async (e) => {
		e.preventDefault();
		setStatus(4);
		setFileMsg({
			type: "working",
			text: "",
		});

		let fileName = file.name;

		/*
      const metadata = {
        customMetadata: {
          name: names.name,
        },
      };
    */

		const path = `bfcFiles/${names.registrationId}/${fileName}`;

		const fileRef = ref(storage, path);
		const uploadTask = await uploadBytes(fileRef, file);
		const downloadUrl = await getDownloadURL(uploadTask.ref);
		//const updatedMetadata = await updateMetadata(fileRef, metadata);
		let newArray = uploads;
		newArray.push({
			name: names.name,
			path,
			downloadUrl,
		});
		setUploads(newArray);
		setStatus(5);
		setFileMsg({});
		/*formElement.current.file.value = ""; can't use here, removing element form DOM after upload*/
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardUpload`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("uploads", JSON.stringify(uploads));
		data.append("auth", getValFromLS("dash", true));
		data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/dashboard/${user.id}`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleRemove = async (indexToRemove) => {
		let source; // bfc_registrations or sponsors
		uploaded.forEach((item, index) => {
			if (index === indexToRemove) {
				source = item.source;
			}
		});

		if (source) {
			//const fileRef = ref(storage, path);
			//const deleted = await deleteObject(fileRef);

			const url = new URL(`${API_URL}/dashboardUploadRemove`);
			let data = new FormData();
			data.append("source", source);
			data.append("indexToRemove", indexToRemove);
			data.append("auth", getValFromLS("dash", true));
			data.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

			try {
				const response = await fetch(url, {
					method: "POST",
					body: data,
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					history.push({
						pathname: `/dashboard/${user.id}`,
						state: {
							message: {
								type: "success",
								text: json.text,
							},
						},
					});
				}
			} catch (error) {}
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Upload Logo & Assets" />

						<p>
							Use this form to upload digital assets, particularly your
							corporate logo.
						</p>

						<p>
							For ads, please upload in vector format (EPS, AI) and video board
							specs of 1280 x 720.
						</p>

						<div className="spacer"></div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
							style={{ paddingBottom: "0" }}
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Upload a File
							</h4>

							{uploads.length === 0 && (
								<div className="form-group">
									<Input
										name="name"
										label="Asset Name (i.e. Logo, Ad, etc.)"
										reqd={true}
										value={names.name || ""}
										autocomplete="off"
										update={handleUpdate}
										errors={errors}
									/>

									<div />
								</div>
							)}

							{uploads.length === 0 && (
								<div className="form-group upload-container">
									<InputFile
										name="file"
										label="Select File"
										reqd={true}
										value={""}
										update={handleInitialize}
										errors={errors}
									/>

									{fileMsg.type ? (
										<div className="upload-status-container">
											<Msg data={fileMsg} inline={true} />
											{status === 3 && (
												<button
													type="button"
													className="btn-alt"
													onClick={(e) => handleUpload(e)}
												>
													Upload File
												</button>
											)}
										</div>
									) : (
										<div className="empty" />
									)}
								</div>
							)}

							{uploads.length > 0 && (
								<div className="form-group one">
									<div>
										<label htmlFor="url" className="control-label">
											<span>
												<i className="fa fa-check success"></i> &nbsp;File
												uploaded, click the add asset button below to complete
												the process.
											</span>
										</label>

										{/*uploads.map((url, index) => {
                      return (
                        <input
                          key={index}
                          type="text"
                          value={url}
                          className="form-control"
                          readOnly={true}
                          style={{ marginTop: index === 0 ? "5px" : "7.5px" }}
                        />
                      );
                    })*/}
									</div>
								</div>
							)}

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									{uploads.length > 0 && <Submit submit="Add Asset" />}
								</div>
							</div>
						</form>

						<table className="approved assigned" style={{ marginTop: "25px" }}>
							<thead>
								<tr>
									<th colSpan="3" className="hdg">
										Your Uploaded Assets
									</th>
								</tr>
								<tr>
									<td className="left">File Name</td>
									<td style={{ width: "20%" }}>View</td>
									<td style={{ width: "20%" }}>Remove</td>
								</tr>
							</thead>
							{uploaded.length > 0 ? (
								<tbody>
									{uploaded.map((item, index) => {
										return (
											<tr key={index}>
												<td className="left">{item.name}</td>
												<td>
													<a
														href={item.downloadUrl}
														target="_blank"
														rel="noreferrer"
													>
														<i className="fa fa-download fa-lg" />
													</a>
												</td>
												<td>
													<button
														type="button"
														className="naked"
														onClick={() => handleRemove(index)}
													>
														<i className="fa fa-trash fa-lg error" />
													</button>
												</td>
											</tr>
										);
									})}
								</tbody>
							) : (
								<tbody>
									<tr>
										<td
											className="center working"
											colSpan="3"
											style={{
												paddingTop: "7.5px",
												paddingBottom: "7.5px",
											}}
										>
											-- No Assets Uploaded --
										</td>
									</tr>
								</tbody>
							)}
						</table>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={8} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Upload;
